import type { QueryClient } from '@tanstack/react-query';

import {
  updateClassroomsCount,
  updateOrganizationCount,
  updateSingleClassroomCount,
} from './cache-utils';

type AddStudent = {
  queryClient: QueryClient;
  organizationId: string;
  classroomId: string;
};

function addStudentInCache({
  queryClient,
  organizationId,
  classroomId,
}: AddStudent): void {
  updateOrganizationCount({
    queryClient,
    organizationId,
    studentsChange: 1,
  });

  updateSingleClassroomCount({
    queryClient,
    classroomId,
    organizationId,
    countChange: 1,
  });

  updateClassroomsCount({
    queryClient,
    organizationId,
    updates: [{ classroomId, countChange: 1 }],
  });
}

export { addStudentInCache };
